<nav class="subnav">
  <ul class="nav">
    <li class="nav-item" *ngFor="let item of statusButtons let i = index" >
      <a class="nav-link" [class.active]="status === item.state" (click)="changeOverviewStatus(i)">{{ item.display }}</a>
    </li>
  </ul>
</nav>

<main>
  <app-invoices-overview [status]="status"></app-invoices-overview>
</main>
